export { ClearAnchorsButton } from './ClearAnchorsButton.component';
